import React from "react";
import { baseUrl } from "../../../libs/env";
import { size } from "lodash";
import { Button } from "../../components/ui/button";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useMobileView } from "../../../speech_pages/components/MobileViewContext";
import {
  AccountType,
  assessmentFlow,
} from "../../../components/constants/constants";
import { Exitbtn } from "../../../components/buttons/exitbtn";
import B2CSubmitButton from "../../../components/buttons/B2C_SubmitButton";
import { BGlevelColors } from "../../components/levelColors";
import { notify } from "../../../components/notification/Notification";

export const ElabAssessmentButtons = ({
  currentSection,
  setCurrentSection,
  currentSectionPage,
  IsonRecorder,
  setCurrentSectionPage,
  pagesOfCurrentSection,
  total_sections,
  data,
  isSubmitting,
  isReview,
  isAiGradingexercise,
  GWarningToggle,
  AisubmissionCounter,
  setAisubmissionCounter,
  sectionCounter,
  setsectionCounter,
}) => {
  let {isMobileView} = useMobileView();
  let showNextButton = true;
  let currentNextSection = currentSection;
  let currentNextSectionPage = currentSectionPage;
  if (isReview && data.sections) {
    total_sections = data.sections[0].section_number;
  }
  if (
    pagesOfCurrentSection === currentNextSectionPage &&
    currentSection !== total_sections
  ) {
    currentNextSection = currentNextSection + 1;
    currentNextSectionPage = 0;
  }

  if (
    currentNextSection === total_sections &&
    pagesOfCurrentSection === currentNextSectionPage
  ) {
    showNextButton = false;
  }

  let backButtonCurrentSection = currentSection;
  let backButtonCurrentPage = currentSectionPage;
  if (isReview || backButtonCurrentSection !== 1) {
    if (currentSectionPage === 1) backButtonCurrentSection -= 1;
    else backButtonCurrentPage -= 1;
    data &&
      data.sessions &&
      data.sessions.forEach((session) => {
        if (session.section_number === backButtonCurrentPage) {
          backButtonCurrentPage = session.total_pages;
        }
      });
    // backButtonCurrentPage = 6;
  }
  const handleNextclick = () => {
    setCurrentSection(currentNextSection);
    setCurrentSectionPage(
      parseInt(`${currentNextSection}${currentNextSectionPage + 1}`)
    );
    if (isAiGradingexercise && data?.is_premium && AisubmissionCounter > 0) {
      setAisubmissionCounter(parseInt(`${AisubmissionCounter - 1}`));
      setsectionCounter((prevState) => {
        const newCount = (prevState[`${currentNextSection}`] || 0) + 1;
        return { ...prevState, [`${currentNextSection}`]: newCount };
      });
    }
  };
  const handlePrevclick = () => {
    setCurrentSection(backButtonCurrentSection);
    setCurrentSectionPage(
      parseInt(`${backButtonCurrentSection}${backButtonCurrentPage}`)
    );
    if (AisubmissionCounter < data?.remaining_credits) {
      setAisubmissionCounter((prevCounter) => {
        const increment = sectionCounter[`${backButtonCurrentSection}`] || 0;
        return Math.max(prevCounter + increment, 0);
      });
      setsectionCounter((prevState) => {
        return { ...prevState, [`${backButtonCurrentSection}`]: 0 };
      });
    }
  };

  const getLevelColor = () => {
    const level = Array.isArray(data.level[0])
      ? data.level[0][0]
      : data.level[0];
    return BGlevelColors[level];
  };

  return (
    <div className={`bg-white border-t ${isMobileView ? "mt-4" : "elab-footer-bottom"}`}>
        {isReview || data.user_type === AccountType.STAFF ? (
          <div className="container mx-auto px-6 py-3 flex items-center justify-content-end">
          <div className="flex gap-4">
            {(currentSectionPage === 1 && isReview) ||
            (!isReview &&
              currentSectionPage === 1 &&
              total_sections === 1) ? null : (
              <Button
                type="button"
                variant="outline"
                size="lg"
                className="border-2 text-gray-600 hover:bg-gray-50"
                onClick={() => {
                  setCurrentSection(backButtonCurrentSection);
                  setCurrentSectionPage(
                    parseInt(
                      `${backButtonCurrentSection}${backButtonCurrentPage}`
                    )
                  );
                }}
              >
                <ChevronLeft className="w-4 h-4" />
                Previous
              </Button>
            )}
            {showNextButton ? (
              <Button
                type="button"
                onClick={() => {
                  setCurrentSection(currentNextSection);
                  setCurrentSectionPage(
                    parseInt(
                      `${currentNextSection}${currentNextSectionPage + 1}`
                    )
                  );
                }}
                size="lg"
                className={`${getLevelColor()} text-white hover:opacity-90`}
              >
                Next
                <ChevronRight className="w-4 h-4" />
              </Button>
            ) : (
              currentSectionPage === 1 &&
              data.user_type !== AccountType.STAFF && (
                <Exitbtn
                  className="border-2 text-gray-600 hover:bg-gray-50 flex items-center gap-2"
                  variant="outline"
                  size="lg"
                  href={
                    localStorage.getItem("reportUrl")
                      ? `${localStorage.getItem("reportUrl")}`
                      : `${baseUrl}/elab/test-performance/${data?.student_assessment_id}/`
                  }
                />
              )
            )}
          </div>
          </div>
        ) : (
          <div className="container mx-auto px-6 py-3 flex items-center justify-between">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={() => {notify("Successfully Saved!"); window.location.href = `${baseUrl}/elab/practice-tests/`;}}
              className="border-2 text-gray-600 hover:bg-gray-50 flex items-center gap-2"
            >
              <Save className="w-4 h-4" />
              Save and Exit
            </Button>

            <div className="flex gap-4">
              {(currentSection === 1 && currentSectionPage === 1) ||
              data.assessment_flow ===
                assessmentFlow.SEQUENTIAL_EARLY_STOP ? null : (
                <Button
                  type="button"
                  onClick={handlePrevclick}
                  variant="outline"
                  size="lg"
                  className="border-2 text-gray-600 hover:bg-gray-50 flex items-center gap-2"
                >
                  <ChevronLeft className="w-4 h-4" />
                  Previous
                </Button>
              )}
              {showNextButton &&
              data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP ? (
                <Button
                  type="button"
                  onClick={handleNextclick}
                  size="lg"
                  className={`${getLevelColor()} text-white hover:opacity-90 flex items-center gap-2`}
                >
                  Next
                  <ChevronRight className="w-4 h-4" />
                </Button>
              ) : data.user_type === AccountType.STUDENT ? (
                <B2CSubmitButton
                  size="lg"
                  className={`${getLevelColor()} text-white hover:opacity-90 py-1 px-8 flex items-center gap-2`}
                  isSubmitting={isSubmitting}
                  btnContent={
                    data.assessment_flow ===
                      assessmentFlow.SEQUENTIAL_EARLY_STOP &&
                    size(data.sections_pages) > 1
                      ? "Next"
                      : "Submit"
                  }
                />
              ) : null}
            </div>
          </div>
        )}
    </div>
  );
};
